import EventsEmitter from "events/EventsEmitter";
import _ from 'utils/@lodash';

export let cachedData: any = {
    views: {},
    projects: {},
    entities: {},
    pending: {},
    snapshots: {},
    comments: {},
    projectsRef: [],
    loaded: false,
    error: false,
};

export const entitiesCache: any = {};

export const getCachedData = (type?: string) => {
    if (type) {
        return cachedData[type];
    } else {
        return cachedData;
    }
};
export const setCachedData = (currentData: any, updateStore: boolean = true) => {
    //if (_.isEqual(cachedData, currentData)) return;
    cachedData = currentData;
    updateStore && EventsEmitter.emit("cacheUpdate", "");
};

var _tempEntities: any = [];

export const setTempEntities = (tmp: any) => {
    _tempEntities = tmp;
};

export const getTempEntities = () => {
    return _tempEntities;
};

export const setProjectData = (type: string, projectId: string, data: any) => {
    cachedData[type][projectId] = data;
};

export const updateEntityToCache = (type: string, projectId: string, entity: any) => {
    let newEntity = null;
    if (type === "views") {
        newEntity = {};
        if (cachedData[type][entity.ID]) {
            if (_.isEqual(cachedData[type][entity.ID], entity)) return;

            newEntity = { ...cachedData[type][entity.ID], ...entity };
        } else {
            newEntity = entity;
        }
        cachedData[type][entity.ID] = newEntity;
    } else if (type === "projects") {
        newEntity = entity;
        cachedData[type][projectId] = newEntity;
    } else if (cachedData[type][projectId]) {
        newEntity = {};
        if (cachedData[type][projectId][entity.ID]) {
            if (_.isEqual(cachedData[type][projectId][entity.ID], entity)) return;
            newEntity = { ...cachedData[type][projectId][entity.ID], ...entity };
        } else {
            newEntity = entity;
        }
        cachedData[type][projectId][entity.ID] = newEntity;
    }
    setCachedData(cachedData, false);

    const channel = new BroadcastChannel('cachedData');
    channel.postMessage({'cachedData' : cachedData});

    console.log("cachedData:", cachedData);
    return newEntity;
};

interface EntyToUpdate {
    type: string;
    projectId: string;
    entity: any;
}

export const updateEntitiesToCache = (entities: EntyToUpdate[]) => {
    entities.map((item: EntyToUpdate) => {
        const { type, projectId, entity } = item;
        
        let newEntity = null;
        if (type === "views") {
            newEntity = {};
            if (cachedData[type][entity.ID]) {
                if (_.isEqual(cachedData[type][entity.ID], entity)) return;
                newEntity = { ...cachedData[type][entity.ID], ...entity };
            } else {
                newEntity = entity;
            }
            cachedData[type][entity.ID] = newEntity;
        } else if (type === "projects") {
            newEntity = entity;
            cachedData[type][projectId] = newEntity;
        } else if (cachedData[type][projectId]) {
            newEntity = {};
            if (cachedData[type][projectId][entity.ID]) {
                if (_.isEqual(cachedData[type][projectId][entity.ID], entity)) return;
                newEntity = { ...cachedData[type][projectId][entity.ID], ...entity };
            } else {
                newEntity = entity;
            }
            cachedData[type][projectId][entity.ID] = newEntity;
        }
    });
    setCachedData(cachedData, false);
    console.log("cachedData:", cachedData);
};

export const updateViewsCache = (view: any) => {
    let neView = {};
    if (cachedData["views"][view.ID]) {
        if (_.isEqual(cachedData["views"][view.ID], view)) return;
        neView = { ...cachedData["views"][view.ID], ...view };
    } else {
        neView = view;
    }
    cachedData["views"][view.ID] = neView;
};

export const deleteEntityFromCache = (projectId: string, entityId: string) => {
    if (cachedData["entities"][projectId]) {
        if (cachedData["entities"][projectId][entityId]) {
            delete cachedData["entities"][projectId][entityId];
        }
    }
};

export const deleteProjectFromCache = (projectId: string) => {
    if (cachedData["entities"][projectId]) {
        delete cachedData["entities"][projectId];
    }
    if (cachedData["projects"][projectId]) {
        delete cachedData["projects"][projectId];
    }
    const deletedProjectIndex = cachedData["projectsRef"].findIndex(
        (projRef: any) => projRef["project_ref"] === projectId
    );
    if (deletedProjectIndex > -1) {
        cachedData["projectsRef"].splice(deletedProjectIndex, 1);
    }
};
